import { Fragment, ReactNode } from "react"
import {
  Block,
  BlockProps,
  Divider,
  LabelMedium,
  useStyletron,
} from "@mezo-org/mezo-clay"

import StakingItemContainer from "./StakingItemContainer"

export type ReviewDetailsListItem = {
  label: string
  endEnhancer: ReactNode
}

type ReviewDetailsProps = {
  label: string
  items: ReviewDetailsListItem[]
} & BlockProps

export default function ReviewDetails({
  label,
  items,
  ...props
}: ReviewDetailsProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: theme.sizing.scale300,
      })}
    >
      <LabelMedium>{label}</LabelMedium>
      <Block
        className={css({
          borderRadius: theme.sizing.scale500,
          background: theme.colors.backgroundSecondary,
          padding: `${theme.sizing.scale300} ${theme.sizing.scale600}`,
        })}
        {...props}
      >
        {items.map((item, index) => (
          <Fragment key={item.label}>
            <StakingItemContainer
              padding={`${theme.sizing.scale300} 0`}
              {...props}
            >
              <LabelMedium>{item.label}</LabelMedium>
              <Block
                className={css({
                  textAlign: "right",
                })}
              >
                {item.endEnhancer}
              </Block>
            </StakingItemContainer>

            {items.length - 1 !== index && (
              <Block
                className={css({
                  margin: `${theme.sizing.scale100} 0`,
                })}
              >
                <Divider $size="cell" />
              </Block>
            )}
          </Fragment>
        ))}
      </Block>
    </Block>
  )
}
